import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { WHATSAPP_GROUP_URL } from '../utils/community';

const FACEBOOK_URL = 'https://www.facebook.com/1138184156050158';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-main">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="Demarcheur">
            <img src="/brand/logo-mark.png" alt="" className="footer-logo-mark" />
            <span className="footer-logo-text">
              <strong>Démarcheur</strong>
              <small>La bonne démarche, au bon endroit.</small>
            </span>
          </Link>
          <p>La plateforme immobilière de référence en Guinée. Trouvez votre maison, terrain ou location à Conakry et partout dans le pays.</p>
          <div className="footer-contact">
            <a href="tel:+224610100165">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.41 2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.09a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              +224 610 10 01 65
            </a>
            <a href="mailto:contact@demarcheur.org">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              contact@demarcheur.org
            </a>
            <a href="https://wa.me/224610100165" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              WhatsApp
            </a>
          </div>
          <div className="footer-social">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" title="Facebook" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://wa.me/224610100165" target="_blank" rel="noopener noreferrer" title="WhatsApp" aria-label="WhatsApp">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            </a>
            <a href="#!" title="Instagram" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Annonces</h4>
          <ul>
            <li><Link to="/?type=location">Locations</Link></li>
            <li><Link to="/?type=vente-maison">Ventes maison</Link></li>
            <li><Link to="/?type=terrain">Terrains</Link></li>
            <li><Link to="/besoins">Demandes immobilières</Link></li>
            <li><Link to="/agences">Agences vérifiées</Link></li>
            <li><Link to="/diaspora">Acheter depuis la diaspora</Link></li>
            <li><Link to="/guide/terrain-a-vendre-guinee">Terrains en Guinée</Link></li>
            <li><Link to="/guide/location-courte-duree-conakry">Location courte durée</Link></li>
            <li><Link to="/nouvelle-annonce">Publier une annonce</Link></li>
            <li><Link to="/publier-besoin">Publier un besoin</Link></li>
            <li><a href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer">Rejoindre le groupe WhatsApp</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Villes</h4>
          <ul>
            <li><Link to="/?ville=Conakry">Conakry</Link></li>
            <li><Link to="/?ville=Kindia">Kindia</Link></li>
            <li><Link to="/?ville=Labé">Labé</Link></li>
            <li><Link to="/?ville=Kankan">Kankan</Link></li>
            <li><Link to="/?ville=Nzérékoré">Nzérékoré</Link></li>
            <li><Link to="/?ville=Boké">Boké</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Compte</h4>
          <ul>
            <li><Link to="/inscription">S'inscrire</Link></li>
            <li><Link to="/connexion">Se connecter</Link></li>
            <li><Link to="/tarifs">Offres agences</Link></li>
            <li><Link to="/tableau-de-bord">Mon espace</Link></li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>
          © {new Date().getFullYear()} Démarcheur. Tous droits réservés.
          <span className="footer-bottom-badge">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            Conakry, Guinée
          </span>
        </p>
        <div className="footer-bottom-links">
          <Link to="/confidentialite">Confidentialité</Link>
          <Link to="/conditions">Conditions</Link>
          <Link to="/tarifs">Tarifs</Link>
          <a href="mailto:contact@demarcheur.org">Contact</a>
        </div>
      </div>
    </footer>
  );
}
